import React, { SVGProps } from 'react';

export const InfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    color="rgb(105, 110, 124)"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0012 0zm1.2 16.2a.6.6 0 01-.6.6h-1.2a.6.6 0 01-.6-.6v-3.6a.6.6 0 01.6-.6h1.2a.6.6 0 01.6.6v3.6zm-.6-6.6a.6.6 0 00.6-.6V7.8a.6.6 0 00-.6-.6h-1.2a.6.6 0 00-.6.6V9a.6.6 0 00.6.6h1.2z"
      clipRule="evenodd"
    />
  </svg>
);
